import { request as ajax } from '@/utils/axios'
import config from '@/config'

export function get(url, { isMock, error, isShowToast = true, ...params } = {}, other = {}) {
  return ajax(
    {
      url,
      method: 'get',
      data: params,
      mock: isMock,
      error,
      isShowToast,
    },
    {
      prefix: config.mobServer,
      ...other,
    }
  )
}

export function post(
  url,
  { isMock, isApp, yundianToken, error, isShowToast = true, signal, ...params } = {},
  other = {}
) {
  console.log(error,'error');
  return ajax(
    {
      url,
      method: 'post',
      data: params,
      mock: isMock,
      error,
      isShowToast,
      signal,
      ...(isApp && {
        headers: {
          version: '5.0.1',
          os: 'android',
        },
      }),
      ...(yundianToken && {
        headers: {
          token: yundianToken,
        },
      }),
    },
    {
      prefix: config.mobServer,
      ...other,
    }
  )
}
